// Single source of truth for profile data.
// Edit here and all pages update automatically.

export const PROFILE = {
    name: "Natanael Geraldo",
    tagline: "Full-Stack Engineer (.NET & React)",
    yearsOfExperience: "5+",
    currentCompany: "Cora Group PTY LTD",
    location: "Australia",
    availability: "Available · Open to Opportunities",
    email: "geraldonatanael84@gmail.com",
    phone: "+62 87781857116",
    website: "natanaelgeraldo.com",
    linkedin: "https://www.linkedin.com/in/natanael-geraldo-sulaiman-952a561a9",
    github: "https://github.com/NatanaelGeraldoS",
    instagram: "https://www.instagram.com/natanaelgeraldo_",
};

export const EXPERIENCE = [
    {
        key: "cora",
        subTitle: "Full-Stack Engineer",
        company: "Cora Group PTY LTD",
        year: "May 2025 – Present",
        description:
            "Leading the development of scalable internal enterprise platforms using .NET and React, owning system architecture, backend design, API integrations, and Azure-based deployments. Delivering production systems that support cross-department workflows and real operational usage while maintaining high availability and performance standards.",
        metrics: [
            "5+ Internal Systems Deployed",
            "Multi-Department Platform Coverage",
            "Architecture & Full-Cycle Ownership",
            "High-Availability Deployment Practices",
        ],
    },
    {
        key: "binus-programmer",
        subTitle: "Programmer",
        company: "IT Division · Bina Nusantara Group",
        year: "October 2023 – February 2025",
        description:
            "Led development and maintenance of enterprise-grade web and desktop systems using ASP.NET Core, C#, and SQL Server. Optimized complex SQL queries to improve response time across critical modules and contributed to architectural decisions for system enhancements and feature rollouts.",
        metrics: [
            "5+ Enterprise Applications",
            "SQL Performance Optimization",
            "Legacy .NET Module Refactoring",
        ],
    },
    {
        key: "binus-junior",
        subTitle: "Junior Programmer",
        company: "IT Division · Bina Nusantara Group",
        year: "March 2022 – October 2023",
        description:
            "Developed and maintained internal business systems across multiple departments. Progressed from feature execution to independently owning modules, handling implementation, testing, debugging, and deployment end-to-end.",
        metrics: [
            "3+ Systems Maintained",
            "Independent Module Ownership",
            "Bug Backlog Reduced ~40%",
        ],
    },
    {
        key: "binus-mentor",
        subTitle: "Scholarship Mentor",
        company: "Bina Nusantara University",
        year: "October 2021 – May 2022",
        description:
            "Mentored students in Artificial Intelligence, Computer Networks, Algorithm Design, and Database Systems, providing structured technical guidance and academic support.",
        metrics: ["10+ Students Mentored", "5 Core Technical Subjects"],
    },
    {
        key: "binus-associate",
        subTitle: "Associate Member",
        company: "IT Division · Bina Nusantara Group",
        year: "March 2021 – March 2022",
        description:
            "Supported internal service desk platforms and implemented configuration adjustments for student, parent, and staff-facing systems at BINUS School Serpong.",
        metrics: [],
    },
];
